export default class Reservation {
  constructor({ id, type, date, userId, userName, people, confirmed, subtype, genre, route }) {
    this.id = id;
    this.type = type;
    this.date = date;
    this.userId = userId;
    this.userName = userName;
    this.people = people || 1;
    this.confirmed = !!confirmed;
    if (!!subtype) {
      this.subtype = subtype;
    }
    if (!!genre) {
      this.genre = genre;
    }
    if (!!route) {
      this.route = route;
    }
    this.tipologia = 'reservation';
  }
}
